import { cn } from '@/lib/utils';

const LINES = ['w-2/5', 'w-11/12', 'w-3/4', 'w-11/12', 'w-1/2', 'w-4/5', 'w-2/3'];

const PaperSkeleton = ({ className }: { className?: string }) => (
	<div className={cn('flex aspect-[8.5/11] w-full flex-col gap-[5%] rounded-md bg-white p-[9%] shadow-sm', className)}>
		{LINES.map((width, index) => (
			<span
				key={index}
				className={cn('bg-h-neutral-94 h-[2.5%] min-h-1 animate-pulse rounded-full', width)}
			/>
		))}
	</div>
);

export default PaperSkeleton;
